import Vue from 'vue'
import Vuex from 'vuex'
import { auth } from './auth'
import { ui } from './ui'

Vue.use(Vuex)
Vue.config.devtools = process.env.NODE_ENV === 'development'
export default new Vuex.Store({
  state: {
    connectionRetryCount: 0
  },
  modules: {
    auth,
    ui
  }
})
